import { jsx as _jsx } from "react/jsx-runtime";
import Add from "components/Emails/Add";
import ADD_EMAILS_FOOTERS from "mutations/emails/addEmailsFooter";
import GET_EMAILS_FOOTERS from "queries/emails/getEmailsFooters";
const FootersAdd = () => (_jsx(Add, { addMutation: ADD_EMAILS_FOOTERS, itemName: "footer", listQuery: GET_EMAILS_FOOTERS }));
export default FootersAdd;
